(function (global, factory) {
	typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('polythene-react-base'), require('polythene-core-ripple')) :
	typeof define === 'function' && define.amd ? define(['exports', 'polythene-react-base', 'polythene-core-ripple'], factory) :
	(factory((global.polythene = {}),global['polythene-react-base'],global['polythene-core-ripple']));
}(this, (function (exports,polytheneReactBase,polytheneCoreRipple) { 'use strict';

var Ripple = polytheneReactBase.StateComponent(polytheneCoreRipple.coreRipple);

Ripple.displayName = "Ripple";

exports.Ripple = Ripple;

Object.defineProperty(exports, '__esModule', { value: true });

})));
//# sourceMappingURL=polythene-react-ripple.js.map



//////////////////
// WEBPACK FOOTER
// ./~/polythene-react-ripple/dist/polythene-react-ripple.js
// module id = 25
// module chunks = 35783957827783 114276838955818 213816032691115